import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const PlanCard = ({ plan }) => {
  const Icon = plan.icon;
  return (
    <Link
      to={`/${plan.slug}`}
      data-testid={`plan-card-${plan.slug}`}
      className="card-lift group relative flex flex-col w-full bg-white border border-slate-200 rounded-2xl p-7 hover:border-[var(--brand-primary)]"
    >
      <div className="flex items-start justify-between">
        <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[var(--bg-secondary)] text-[var(--brand-primary)]">
          <Icon className="w-5 h-5" />
        </span>
        <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-[var(--brand-primary)] transition-colors" />
      </div>
      <h3 className="font-display text-2xl mt-6 text-[var(--ink)]">{plan.name}</h3>
      <p className="mt-3 text-sm text-slate-600 leading-relaxed">{plan.short}</p>
      <p className="mt-6 eyebrow text-[var(--brand-primary)]">{plan.audience}</p>
    </Link>
  );
};
